import { useEffect, useRef } from "react";
import { motion, useMotionValue, animate } from "framer-motion";

function AnimatedPct({ value, className, testId }) {
  const ref = useRef(null);
  const mv = useMotionValue(50);
  useEffect(() => {
    const controls = animate(mv, value, {
      duration: 0.9, ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => { if (ref.current) ref.current.textContent = `${Math.round(v)}%`; },
    });
    return () => controls.stop();
  }, [value, mv]);
  return <span ref={ref} className={className} data-testid={testId}>{Math.round(value)}%</span>;
}

export default function MiniFlip({ votesA, votesB, size = "h-2", kick = false }) {
  const total = votesA + votesB;
  const pctA = total > 0 ? (votesA / total) * 100 : 50;
  const spring = { type: "spring", stiffness: 120, damping: 18, mass: 0.8 };
  const dir = pctA >= 50 ? 1 : -1;
  const over = Math.max(0, Math.min(100, pctA + dir * 9));
  return (
    <div className="flex items-center gap-2 w-full" data-testid="mini-flip">
      <AnimatedPct value={pctA} className="text-xs font-bold text-view-a w-9 tabular-nums" testId="mini-flip-pct-a" />
      <div className={`flex-1 ${size} bg-gray-100 rounded-full overflow-hidden relative`}>
        <motion.div
          className="absolute inset-y-0 left-0 bg-view-a rounded-full"
          initial={{ width: "50%" }}
          animate={{ width: `${pctA}%` }}
          transition={spring}
        />
        <motion.div
          className="absolute inset-y-0 right-0 bg-view-b rounded-full"
          initial={{ width: "50%" }}
          animate={{ width: `${100 - pctA}%` }}
          transition={spring}
        />
        <motion.div
          className="absolute top-1/2 -translate-y-1/2 w-1 h-3 bg-white rounded-full shadow-sm"
          initial={{ left: "50%", scale: 1 }}
          animate={kick
            ? { left: [`calc(${over}% - 2px)`, `calc(${pctA}% - 2px)`], scale: [1, 1.8, 1] }
            : { left: `calc(${pctA}% - 2px)` }}
          transition={kick ? { duration: 0.6, ease: "easeOut" } : spring}
        />
      </div>
      <AnimatedPct value={100 - pctA} className="text-xs font-bold text-view-b w-9 text-right tabular-nums" testId="mini-flip-pct-b" />
    </div>
  );
}
